<template>
  <ValidationObserver ref="wizardPage3" id="wizardPage3" name="wizardPage3">
    <div>
      <h5 v-if="fleetLookupRunning || fleetExtractionRunning" class="text-danger mb-8">Fleet processing in progress - Business locations will be refreshed automatically based on the fleet vehicles.</h5>

      <h5 v-if="!Array.isArray(appData.clientBranches) || appData.clientBranches.length === 0" class="text-danger mb-8">At least 1 business location must be declared.</h5>

      <div class="mb-5">
        <button class="btn btn-primary" v-if="!editingLocations" @click.prevent="editLocations">
          <i class="fa fa-edit"></i> Edit Locations
        </button>
        <button class="btn btn-primary" v-if="editingLocations" @click.prevent="saveLocations">
          <i class="fa fa-save"></i> Save Locations
        </button>
        <button class="btn btn-secondary ml-5" v-if="editingLocations" @click.prevent="cancelEditMode">
          <i class="fa fa-times"></i> Cancel
        </button>
      </div>

      <ValidationObserver ref="locationsList">
        <table>
          <thead>
            <th style="width: 30%"></th>
          </thead>
          <tr v-for="(businessLocation, index) in appData.clientBranches" :key="index">
            <td>
              <b-card class="mb-4" bg-variant="light" body-class="p-4" border-variant="dark">
                <div class="row">
                  <div class="col-12">
                    <label class="text-left font-size-h5"><strong>{{ getDisplayName(businessLocation, index) }}</strong></label>
                    <button v-if="!isReadOnly && editingLocations" class="btn btn-danger btn-sm float-right" @click.prevent="confirmDeletion(index)">
                      Delete
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <business-location :location-entry="businessLocation" :allow-head-office-selection="allowHeadOfficeSelection"
                                       :is-read-only="isReadOnly || !editingLocations"/>
                  </div>
                </div>
              </b-card>
            </td>
          </tr>
          <tr v-if="!isReadOnly && editingLocations">
            <td class="text-center">
              <button class="btn btn-sm btn-primary col-2" @click.prevent="addLocation">
                <i class="fa fa-plus"></i> Add Another Business Location
              </button>
            </td>
          </tr>
        </table>

        <ValidationProvider v-if="!isReadOnly" rules="min_count:1" name="numberOfRentalLocations" v-slot="{ errors }">
          <input type="number" v-model="appData.clientBranches.length" hidden/>
          <span class="text-danger"><br>{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider v-if="!isReadOnly" :rules="{ 'required': { allowFalse: false }}" name="areBranchCodesUnique" v-slot="{ errors }">
          <input hidden="hidden" class="form-control" v-model="areLocationCodesUnique"/>
          <span class="text-danger">{{ errors[0] ? `Branch codes must be unique.` : null }}<br/></span>
        </ValidationProvider>
      </ValidationObserver>

      <!-- Convenience buttons at the bottom of the table -->
      <div class="mb-5" v-if="appData.clientBranches.length > 2">
        <button class="btn btn-primary" v-if="!editingLocations" @click.prevent="editLocations">
          <i class="fa fa-edit"></i> Edit Locations
        </button>
        <button class="btn btn-primary" v-if="editingLocations" @click.prevent="saveLocations">
          <i class="fa fa-save"></i> Save Locations
        </button>
        <button class="btn btn-secondary ml-5" v-if="editingLocations" @click.prevent="cancelEditMode">
          <i class="fa fa-times"></i> Cancel
        </button>
      </div>

      <b-modal ref="deleteLocationConfirmationModal" title="Delete Business Location" size="md" no-close-on-backdrop hide-header-close @ok="deleteLocation">
        <div class="form-group" v-if="locationToBeDeleted">
          Are you sure you want to delete this Business Location?<br/><br/>
          <strong>{{ locationToBeDeleted.K_BranchCode }} - {{ getAddress(locationToBeDeleted) }}</strong>
        </div>
      </b-modal>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import _ from "lodash";
import BusinessLocation from "@/view/pages/wizard/newbusiness-renewal/components/BusinessLocation.vue";

export default {
  name: 'BusinessLocationsPage',
  components: { BusinessLocation },
  props: {
    appData: Object,
    refData: Object,
    isReadOnly: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      editingLocations: false,
      locationsCopy: null,
      locationsInvalid: null,
      locationToBeDeletedIndex: null
    };
  },

  methods: {
    getDisplayName: function (location, index) {
      let displayName = `Business Location ${index+1}`;
      if(location.K_Category === 'Head Office') {
        displayName = displayName + ` (Head Office)`;
      }
      if(location.K_BranchCode) {
        displayName = displayName + ` - ${location.K_BranchCode}`;
      }
      return displayName;
    },

    editLocations: function () {
      this.fleetInvalid = false;
      this.locationsCopy = _.cloneDeep(this.appData.clientBranches);
      this.editingLocations = true;

    },

    saveLocations: async function () {
      const validLocations = await this.$refs.locationsList.validate();
      this.locationsInvalid = !validLocations;
      if(this.locationsInvalid) {
        return;
      }

      this.$emit('saveBusinessLocations', this.appData.clientBranches);
      this.locationsCopy = null;
      this.editingLocations = false;
    },

    cancelEditMode: function () {
      this.locationsInvalid = false;
      this.$set(this.appData, 'clientBranches', this.locationsCopy);
      this.locationsCopy = null;
      this.editingLocations = false;
    },

    addLocation: function () {
      this.appData.clientBranches.push({ addressDetails: { country: 'Australia' } });
    },

    confirmDeletion: function (index) {
      this.locationToBeDeletedIndex = index;
      this.$refs["deleteLocationConfirmationModal"].show();
    },

    deleteLocation: function () {
      if(this.locationToBeDeletedIndex >= 0) {
        this.appData.clientBranches.splice(this.locationToBeDeletedIndex, 1);
      }
      this.locationToBeDeletedIndex = null;
    },

    getAddress: function(branch) {
      let addr = branch.addressDetails;
      if(addr) {
        return [addr.streetAddress, addr.suburb, addr.postcode, addr.state].join(' ');
      }
    }
  },

  computed: {
    fleetLookupRunning: function () {
      return this.appData?.fleetInfo?.K_FleetLookupRunning || false;
    },

    fleetExtractionRunning: function () {
      return this.appData?.fleetInfo.K_FleetExtractionRunning || false;
    },

    allowHeadOfficeSelection: function () {
      if(this.appData && Array.isArray(this.appData.clientBranches)) {
        return !_.some(this.appData.clientBranches, { 'K_Category': 'Head Office'});
      }
      return true;
    },

    locationToBeDeleted: function () {
      if(this.locationToBeDeletedIndex >= 0) {
        return this.appData.clientBranches[this.locationToBeDeletedIndex];
      }
      return null;
    },

    areLocationCodesUnique: function () {
      if(this.appData && Array.isArray(this.appData.clientBranches)) {
        const branchCodes = _.map(this.appData.clientBranches, 'K_BranchCode');
        const uniqueSet = new Set(branchCodes);
        return branchCodes.length === uniqueSet.size;
      }
      return false;
    }
  }
};
</script>
